import React, { useState, useEffect } from "react";
import SuperDealsPage from "../components/DealsPage"; // Updated import name
import { MemoizedDealCard, getDeals } from "../components/DealCard"; // Import getDeals

export default function SuperDeals({ darkMode = false }) {
  const [deals, setDeals] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Fetch deals on mount
    const fetchDeals = async () => {
      try {
        const allDeals = getDeals({
          includeStoredOverrides: true,
          includeCustomDeals: true,
          hydrateRemote: true
        });
        setDeals(allDeals);
      } catch (error) {
        console.error("Error loading deals:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDeals();
  }, []);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-lg font-medium text-gray-600">
          Loading deals...
        </div>
      </div>
    );
  }

  return (
    <SuperDealsPage
      deals={deals}
      darkMode={darkMode}
      DealCardComponent={MemoizedDealCard}
    />
  );
}